export default __webpack_public_path__ + "static/media/AE.90ed6143.svg";